import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListVehicleType({
    loading,
    filteredVehicleTypes,
    selected,
    handleSelect,
    handleToggleStatus,
    getStatusClass,
    getStatusText,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Vehicle Type</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="3" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredVehicleTypes.length > 0 ? (
                        filteredVehicleTypes.map((v) => (
                            <tr key={v.id}>
                                <td>
                                    <input
                                        type="radio"
                                        name="vehicleTypeSelect"
                                        disabled={v.status === "Inactive"}
                                        checked={selected === v.id}
                                        onChange={() => handleSelect(v.id)}
                                    />
                                </td>

                                <td>{v.vehicleType}</td>

                                <td>
                                    <span
                                        className={`badge ${getStatusClass(v.status)}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleToggleStatus(v)}
                                    >
                                        {getStatusText(v.status)}
                                    </span>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" className="text-center text-muted">
                                No vehicle types found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
